// extracted by mini-css-extract-plugin
export default {"container":"ProductByCategory_container__kn832","infinite-scroll-container":"ProductByCategory_infinite-scroll-container__d0cdK"};